import React, { createContext, useContext, useState, useCallback } from "react";
import empApi from "../lib/empApi";

const EmpCtx = createContext(null);

export function EmployeeAuthProvider({ children }) {
  const [employee, setEmployee] = useState(() => {
    try { return JSON.parse(localStorage.getItem("cf_emp") || "null"); } catch { return null; }
  });
  const [loading, setLoading] = useState(false);

  const login = useCallback(async (employee_id, pin) => {
    setLoading(true);
    try {
      const { data } = await empApi.post("/employee/auth/login", { employee_id, pin });
      localStorage.setItem("cf_emp_token", data.access_token);
      localStorage.setItem("cf_emp", JSON.stringify(data.employee));
      setEmployee(data.employee);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: e?.response?.data?.detail || "Login gagal" };
    } finally { setLoading(false); }
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("cf_emp_token");
    localStorage.removeItem("cf_emp");
    setEmployee(null);
    window.location.href = "/karyawan/login";
  }, []);

  const refresh = useCallback((emp) => {
    setEmployee(emp);
    localStorage.setItem("cf_emp", JSON.stringify(emp));
  }, []);

  const changePin = useCallback(async (new_pin, current_pin) => {
    try {
      const { data } = await empApi.post("/employee/auth/change-pin", { new_pin, current_pin });
      localStorage.setItem("cf_emp", JSON.stringify(data.employee));
      setEmployee(data.employee);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: e?.response?.data?.detail || "Gagal mengubah PIN" };
    }
  }, []);

  return (
    <EmpCtx.Provider value={{ employee, loading, login, logout, refresh, changePin }}>
      {children}
    </EmpCtx.Provider>
  );
}

export const useEmployeeAuth = () => useContext(EmpCtx);
